module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/easgLm/tc-custom/9781423644484.jpg?1736951916095",
      "alt": "This image is the cover for the book Mashed"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Mashed\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("The award-winning food writer and author of "), _c('i', [_vm._v("Tart Love")]), _vm._v(" shows you there’s more to mash than potatoes with this amazing collection of recipes.")]), _c('br'), _c('br'), _vm._v(" This fresh take on classic comfort foods includes not only delicious variants on mashed potato dishes, but also gratins, soups, dips, sauces, guacamoles, pâtés, casseroles, panna cottas, and sorbets made with a plethora of vegetables, fruits, beans, grains, nuts, eggs, and even meats. Hot or cold, savory or sweet, classic or innovative, rustic or elegant, "), _c('i', [_vm._v("Mashed")]), _vm._v(" shows that mashing doesn’t need to stop at just traditional mashed potatoes."), _c('br'), _c('br'), _c('b', [_vm._v("“Mashes are redolent of homey comfort, yet can also be sophisticated and elegant, perfect dinner party fare.... This beautiful book carries you through the seasons with recipes that are fresh, simple, and out-of-this-world delicious.”—Jamie Schler, "), _c('i', [_vm._v("Huffington Post")])])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Holly Herrick\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Gibbs Smith\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0